import { BaseApiService } from '@/shared/api/services/base.service';
import type { BrandSelection, BrandSelectionsResponse } from '@/types/brand';

class BrandSelectionsService extends BaseApiService {
  /**
   * Resolve stored tokens into the labels the settings rows print.
   *
   * One call for the whole selection, at every level of the picker: the
   * alternative is fetching brands, lines and colors separately and assembling
   * four levels of summary on the client, three times over on three platforms.
   */
  async resolve(tokens: string[]): Promise<BrandSelection[]> {
    if (tokens.length === 0) return [];

    const query = new URLSearchParams({ tokens: tokens.join(',') });
    const response = await this.httpGet<BrandSelectionsResponse>(
      `/v1/brand-selections?${query.toString()}`
    );

    return response.data;
  }
}

export const brandSelectionsService = new BrandSelectionsService();
